import { useSelector } from 'react-redux';
import { VIDEO_REMOVE_BG_USE_CREDIT } from '../redux/slices/FJSliceVideoBgRemover';
import FJLocalStore from '../store/FJLocalStore';

const useUsageDetailContainer = () => {
    const totalTime = useSelector(state => state.videoBgRemover.totalTime);

    const label1 = 'remove-background';
    const value1 = `${VIDEO_REMOVE_BG_USE_CREDIT} ${FJLocalStore._('credits')}/s`;
    const label2 = 'duration';
    const value2 = `${Math.floor(totalTime)} s`;
    const tutalCredit = (Math.floor(totalTime) * VIDEO_REMOVE_BG_USE_CREDIT).toFixed(1);

    return {
        label1,
        value1,
        label2,
        value2,
        tutalCredit,
    };
};

export default useUsageDetailContainer;
